'use strict';

var Reflux             = require('reflux'),
    Application        = require('js/shared/models/application.js'),
    StoreActions       = require('js/shared/actions/store-actions.js'),
    ApplicationActions = require('js/shared/actions/application-actions.js');

module.exports = Reflux.createStore({

    init: function () {

        this.universityResults = {};
        this.universities = {};

        this.listenTo(StoreActions.__loadUser.completed, this.onLoadUser);

        this.listenTo(ApplicationActions.searchUniversities.completed, this.onSearchUniversities);
        this.listenTo(ApplicationActions.createNewSchool.completed, this.onCreateNewSchoolCompleted);
        this.listenTo(ApplicationActions.createNewSchool, this.onCreateNewSchoolBefore);
    },

    getState: function() {
        return {
            dataIsLoaded: true,
            universityResults: this.universityResults,
            universities: this.universities
        };
    },

    onLoadUser: function(resp) {
        var user_resp = resp.body;

        if (user_resp.education !== null) {
            this.universities[user_resp.education.institution_id] = {
                id: user_resp.education.institution_id,
                name: user_resp.education.institution
            };
        }

        this.trigger('loadUser');
    },

    onSearchUniversities: function(resp) {
        var query = decodeURIComponent(resp.req._query[0].slice(2));
        this.universityResults[query] = resp.body;

        resp.body.forEach(function(uni) {
            this.universities[uni.id] = uni;
        }.bind(this));

        this.trigger('searchUniversities');
    },

    onCreateNewSchoolCompleted: function(resp) {
        this.universities[resp.body.id] = resp.body;
        this.trigger('createNewSchoolCompleted');
    },

    onCreateNewSchoolBefore: function(schoolName, country, institutionType) {
        this.universities.submitted = {
            id: "submitted",
            name: schoolName,
            institution_type: institutionType
        };
        this.trigger('createNewSchoolBefore');
    },

});



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/stores/universitysearch-store.js
 ** module id = 330
 ** module chunks = 0 1 6
 **/